import React from 'react';
import { NavLink } from 'react-router-dom';
import CustomTable, { TTableColumn } from '../../../../_shared/custom/customTable/CustomTable';
import { TSale } from '../../../_models';
import { translations } from '../../../../_translations';
import { parseCurrency } from '../../../../_utils/parseHelpers';

const columns: TTableColumn[] = [
  {
    label: translations.getLabel('STOCKITEMS.TABLE.DATE'),
    name: 'cashSheetDate',
  },
  {
    className: 'large-column',
    label: translations.getLabel('CASH_SHEETS.OVERVIEW.TABLE.CLIENT_NAME'),
    name: 'clientName',
  },
  {
    className: 'small-column',
    label: translations.getLabel('CASH_SHEETS.OVERVIEW.TABLE.RECEIPT_CODE'),
    name: 'receiptCode',
  },
  {
    className: 'smallest-column',
    label: translations.getLabel('CASH_SHEETS.OVERVIEW.TABLE.SELLER'),
    name: 'seller',
  },
  { label: translations.getLabel('CASH_SHEETS.OVERVIEW.TABLE.AMOUNT'), name: 'totalPrice' },
  { label: translations.getLabel('CASH_SHEETS.OVERVIEW.TABLE.CASH'), name: 'paidCash' },
  { label: translations.getLabel('CASH_SHEETS.OVERVIEW.TABLE.BANCONTACT'), name: 'paidBancontact' },
  { label: translations.getLabel('CASH_SHEETS.OVERVIEW.TABLE.CREDITCARD'), name: 'paidCreditcard' },
  {
    label: translations.getLabel('CASH_SHEETS.OVERVIEW.TABLE.PORTABLE_BANCONTACT'),
    name: 'paidBancontactPortable',
  },
  {
    label: translations.getLabel('CASH_SHEETS.OVERVIEW.TABLE.PORTABLE_CREDITCARD'),
    name: 'paidCreditCardPortable',
  },
  { label: translations.getLabel('CASH_SHEETS.OVERVIEW.TABLE.COUPON'), name: 'paidCheck' },
  {
    label: translations.getLabel('CASH_SHEETS.OVERVIEW.TABLE.BANK_TRANSFER'),
    name: 'paidBankTransfer',
  },
];

type TProps = {
  data?: TSale[];
  isLoading?: boolean;
  setDate: (date: string) => void;
  storeId: string;
};

const SalesSearchTable: React.FC<TProps> = ({ data, isLoading, storeId, setDate }) => {
  function renderRow(sale: TSale, index: number): JSX.Element {
    return (
      <CustomTable.Row className={sale?.highlight?.toLowerCase()} key={index}>
        <CustomTable.Cell className="underline">
          <NavLink onClick={() => setDate(sale.cashSheetDate)} to={`/cash-sheets/${storeId}`}>
            {sale.cashSheetDate}
          </NavLink>
        </CustomTable.Cell>
        <CustomTable.Cell>{sale.clientName}</CustomTable.Cell>
        <CustomTable.Cell>{sale.receiptCode}</CustomTable.Cell>
        <CustomTable.Cell>{sale.seller}</CustomTable.Cell>
        <CustomTable.Cell className="bold">{parseCurrency(sale.totalPrice)}</CustomTable.Cell>
        <CustomTable.Cell>{parseCurrency(sale.paidCash)}</CustomTable.Cell>
        <CustomTable.Cell>{parseCurrency(sale.paidBancontact)}</CustomTable.Cell>
        <CustomTable.Cell>{parseCurrency(sale.paidCreditCard)}</CustomTable.Cell>
        <CustomTable.Cell>{parseCurrency(sale.paidBancontactPortable)}</CustomTable.Cell>
        <CustomTable.Cell>{parseCurrency(sale.paidCreditCardPortable)}</CustomTable.Cell>
        <CustomTable.Cell>{parseCurrency(sale.paidCheck)}</CustomTable.Cell>
        <CustomTable.Cell>{parseCurrency(sale.paidBankTransfer)}</CustomTable.Cell>
      </CustomTable.Row>
    );
  }

  return <CustomTable columns={columns} data={data} isLoading={isLoading} renderRow={renderRow} />;
};

export default SalesSearchTable;
